import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CxoneObjectivesService } from '../cxone-objectives.service';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
    selector: 'cv-context-menu-cell-renderer',
    templateUrl: './context-menu-cell-renderer.component.html',
    styleUrls: ['./context-menu-cell-renderer.component.scss']
})
export class CxoneContextMenuCellRendererComponent implements OnInit, ICellRendererAngularComp {
    public params: ICellRendererParams;
    public objectiveID: number;
    public defintion: any;
    @ViewChild('actionPopover') actionPopover: PopoverDirective;


    constructor(
        private service: CxoneObjectivesService
    ) { }
    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.objectiveID = params.data.ObjectiveID;
        this.defintion = params.node.data;
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }

    ngOnInit(): void { }

    public confirmDelete() {
        this.params.context.DeactivateObjective();
    }

    public activatePopover(popover: NgbPopover) {
        this.service.popoverObj = popover;
    }

    public editClick() {
        this.actionPopover.hide();
        this.params.context.editClick(this.defintion);
    }

    public deleteClick(popover: NgbPopover) {
        this.activatePopover(popover);
        this.params.context.deleteClick(this.defintion);
    }

    public getPopoverPosition(event) {
        // if the button is near the bottom of the grid open popover upwards
        let buttonElement = event.target as HTMLElement;
        let viewportElement = document.querySelector('.ag-body');
        if (buttonElement && viewportElement) {
          let viewportPos = viewportElement.getBoundingClientRect();
          let buttonPos = buttonElement.getBoundingClientRect();
  
          if (buttonPos.bottom + 50  > viewportPos.bottom) { 
            this.actionPopover.placement= 'top';
            return;
          }
        }
      this.actionPopover.placement = 'left';
    }
  
    public showPopover(event): void {
      this.getPopoverPosition(event);
      this.actionPopover.show();
    }

}
